import { LoadingButton } from '@mui/lab';
import { Box, Card, Grid, Modal, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '../../../icons/close.svg';
import SpinnerWithNoConfirmation from '../../../shared/Modal/spinnerWithNoConfirmation';
import { getDownloadWorkOrderFile, selectWorkOrderState } from '../sagas/workorderSlice';

export interface AttachmentsModalProps {
  open: boolean;
  onClose: () => void;
  base64Url?: string;
  title: string;
  remoteUuid: string;
}
export default function AttachmentsModal(props: AttachmentsModalProps) {
  const { isFetchingVideos, MaintenanceVideo, isDownloadingWorkOrderFiles } = useSelector(selectWorkOrderState);
  const dispatch = useDispatch();
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    height: '523px',
    pointerEvents: "auto",
    width: '98%',
    maxWidth: '472px',
    borderRadius: '24px',
    outline: 'none',
  };
  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      BackdropProps={{
        invisible: false,
      }}
      disableEscapeKeyDown
      disableAutoFocus={true}
    >
      <Card sx={style}>
        <Grid container height="100%" width="100%" display="flex" justifyContent="center">
          <Grid item xs={12} display="flex" justifyContent="center">
            <Typography
              sx={{
                fontFamily: 'Work Sans !important',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '18px !important',
                lineHeight: '21px !important',
                color: '#14142B',
              }}
            >
              {props.title}
            </Typography>
          </Grid>
          {isFetchingVideos ? (
            <Grid item xs={12} display="flex" alignItems="center" justifyContent="center" height="100%">
              <SpinnerWithNoConfirmation />
            </Grid>
          ) : props.title === 'Photo' ? (
            <Grid>
              <img src={props.base64Url} style={{ height: '400px', width: '400px' }} alt="attachments" />
            </Grid>
          ) : (
            <Grid item>
              <video width="450" height="400" controls>
                <source src={MaintenanceVideo.signedUrl} />
              </video>
            </Grid>
          )}
          {/* Save button */}
          <Box sx={{ position: 'absolute', bottom: 15, width: '94%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <LoadingButton
                variant="contained"
                loading={isDownloadingWorkOrderFiles}
                style={{
                  textTransform: 'none',
                  fontFamily: "'Open Sans', sans-serif",
                  fontStyle: 'normal',
                  fontWeight: 700,
                  backgroundColor: '#39A2DB',
                  borderRadius: '24px',
                  width: '115px',
                }}
                onClick={() => {
                  dispatch({
                    type: getDownloadWorkOrderFile.type,
                    payload: {
                      remoteUuid: props.remoteUuid,
                    },
                  });
                }}
              >
                Download
              </LoadingButton>
            </Box>
          </Box>
          {/* Close Icon */}
          <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
            <img
              src={CancelIcon}
              alt="close"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                props.onClose();
              }}
            />
          </Grid>
        </Grid>
      </Card>
    </Modal>
  );
}
